import * as Sentry from "@sentry/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

// components
import TextInput from "../../../components/forms/textInput";
import { ImageUploader } from "../../../components/userProfile/personalData/imageUploader";
import { EUploadImageType } from "../../../s3Integration/enums";
import { uploadFile } from "../../../s3Integration/s3Client";
import { IProfileInfoFormProps } from "../models";
// profielInfo
import styles from "./profileInfo.module.scss";

export const ProfileInfoForm = (props: IProfileInfoFormProps) => {
  const [imageUploading, setImageUploading] = useState<boolean>();
  const [imageUrl, setImageUrl] = useState<string>();
  const [firstName, setFirstName] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const { onChange, userId } = props;
  const { t } = useTranslation();

  const handleOnImageChange = async (e) => {
    setImageUploading(true);
    const image = e?.target?.files[0];
    try {
      if (userId) {
        const url = await uploadFile(image, EUploadImageType.PROFILE, userId);
        setImageUrl(url);
        onChange({ photoUrl: url, firstName, lastName });
        setImageUploading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      console.error(e);
      setImageUploading(false);
    }
  };
  return (
    <div>
      <div className={styles.image_uploader}>
        <ImageUploader
          imageUrl={imageUrl}
          imageUploading={imageUploading}
          handleOnImageChange={handleOnImageChange}
        />
      </div>
      <div className={"row"}>
        <div className={"flex5"}>
          <TextInput
            id="firstName"
            label={t("lbl_form_first_name")}
            maxLength={25}
            handleChange={(e) => {
              setFirstName(e.target.value);
              onChange({
                firstName: e.target.value,
                lastName,
                photoUrl: imageUrl,
              });
            }}
          />
        </div>
        <div className={"flexDivider"} />
        <div className={"flex5"}>
          <TextInput
            id="lastName"
            label={t("lbl_form_last_name")}
            maxLength={25}
            handleChange={(e) => {
              setLastName(e.target.value);
              onChange({
                lastName: e.target.value,
                firstName,
                photoUrl: imageUrl,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};
